export class ResetSupplierAccount {
    public supplierID: string;
}
